export const getBlur = (FOUNDATIONS) => {
    return {
        layerblur_50: `blur(calc(${FOUNDATIONS.blur_150} / 2))`,
    };
};
//# sourceMappingURL=blur.js.map